<template>
  <ib-tooltip
    popper-class="center"
    :content="$t('template.removeUneditedTemplateItems')"
    :disabled="disabled"
  >
    <component
      :is="component"
      :disabled="disabled || loading"
      placement="bottom"
      :text="$t('thisWillRemoveUneditedTemplateItems')"
      @confirm="onConfirm"
    >
      <ib-button-generating
        class="erase-icon-button"
        :height="height"
        color="red"
        font-family="regular"
        :disabled="disabled"
        :loading="loading"
        :transition="false"
        @click="onClick"
      >
        <i class="ib-icon ib-icon-trash" />
        <span class="erase-button-text">{{ $t('deleteTemplates') }}</span>
      </ib-button-generating>
    </component>
  </ib-tooltip>
</template>

<script>
import IbButtonGenerating from '@/components/_v2/Button/IbButtonGenerating.vue'
import IbTooltipConfirm from '@/components/_v2/IbTooltipConfirm'

export default {
  name: 'EraseIconButton',

  components: {
    IbButtonGenerating,
    IbTooltipConfirm
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '44px'
    }
  },

  computed: {
    component () {
      return this.confirm ? 'IbTooltipConfirm' : 'div'
    }
  },

  methods: {
    onClick () {
      if (this.disabled) return
      this.$emit('click')
    },

    onConfirm () {
      if (this.disabled) return
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="scss">
.erase-icon-button {
  ::v-deep{
    padding: 8px 15px;
    box-shadow: none;
    border: solid 1px #e7e7e7;

    span {
      color: $color-red;
    }
  }

  i {
    font-size: 21px;
    padding: 2px 0;
    margin-right: 0;

    @include media-breakpoint-up($md) {
      margin-right: 5px;
    }
  }
  .erase-button-text {
    display: none;

    @include media-breakpoint-up($md) {
      display: flex;
    }
  }
}
</style>
